import React from 'react';
import times from 'lodash/times';
import { TableCell, TableRow } from '../../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { PerformanceTableSkeleton } from './components/PerformanceTableSkeleton/PerformanceTableSkeleton';

export const PerformanceDetailsLoading: React.FC = () => {
  return (
    <PerformanceTableSkeleton>
      {times(7).map(i => (
        <TableRow key={i}>
          <TableCell width="40%">
            <Shimmer width="100%" height={20} />
          </TableCell>

          {times(6).map(j => (
            <TableCell key={j} width="10%">
              <Shimmer width="100%" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </PerformanceTableSkeleton>
  );
};
